import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M8 1.333a6.667 6.667 0 1 0 0 13.334A6.667 6.667 0 0 0 8 1.333m.667 11.954v-.62a.667.667 0 1 0-1.334 0v.62a5.334 5.334 0 0 1-4.62-4.62h.62a.667.667 0 1 0 0-1.334h-.62a5.33 5.33 0 0 1 4.62-4.62v.62a.667.667 0 1 0 1.334 0v-.62a5.334 5.334 0 0 1 4.62 4.62h-.62a.667.667 0 1 0 0 1.334h.62a5.334 5.334 0 0 1-4.62 4.62m1.426-8.254L6.76 6.447a.67.67 0 0 0-.347.346L5 10.127a.67.67 0 0 0 .14.733c.123.126.29.197.467.2a.6.6 0 0 0 .266-.06l3.334-1.413a.67.67 0 0 0 .346-.347l1.414-3.333a.667.667 0 0 0-.874-.874m-1.66 3.4-1.52.667.667-1.52 1.52-.667z"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })